<template>
  <v-app-bar app clipped-right>
    <v-app-bar-nav-icon @click.stop="toggleDrawer" v-if="$vuetify.breakpoint.mobile"/>

    <v-toolbar-title @click="gotoHome()" style="cursor:pointer;">
      <div style="display:flex;">
        <img style=" max-height: 50px;" src="../../assets/logo.png" alt="">
<!--        <img v-if="! $vuetify.breakpoint.mobile" style="align-self: center; max-height: 40px;" src="../../assets/logo-text.png" alt="">-->
      </div>
      <!-- <v-breadcrumbs  :items="breadCrumbs" divider=">">
      </v-breadcrumbs> -->
    </v-toolbar-title>
    <v-spacer/>

    <v-badge content="" value="" overlap>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
    </v-badge>

    <v-btn icon @click="changeLanguage">
      <v-avatar size="36px">
        <img
            v-if="$i18n.locale === 'km'"
            alt=""
            style="background-size: contain"
            src="../../assets/Flag_of_Cambodia.svg"
        />
        <img
            v-if="$i18n.locale === 'en'"
            alt=""
            style="background-size: contain"
            src="../../assets/Flag_of_the_United_States.svg"
        />
      </v-avatar>
    </v-btn>

    <v-menu  offset-y>
      <template v-slot:activator="{ attrs, on }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-avatar size="36px">
            <img
                alt=""
                style="background-size: contain"
                src="../../assets/user.png"
            />
          </v-avatar>
        </v-btn>
      </template>

      <div
        style="min-width: 300px; padding-top: 20px;text-align: center;background-color: white"
      >
        <v-avatar size="100px">
          <img
              alt=""
              style="background-size: contain"
              src="../../assets/user.png"
          />
        </v-avatar>
        <br/>
        {{$store.state.userDoc.full_name }}<br>
        {{decryptFn($store.state.userDoc.username) }} <br>
        ({{$t($store.state.userDoc.type)}})
      </div>
      <v-list>
        <!-- <v-list-item link key="profile">
          <v-list-item-title>
            <v-icon>mdi-account</v-icon>
            {{ $t("myProfile") }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item link>
          <v-list-item-title>
            <v-icon>mdi-lock</v-icon>
            {{ $t("changePassword") }}
          </v-list-item-title>
        </v-list-item> -->

        <v-list-item link>
          <v-list-item-title @click="logout">
            <v-icon>mdi-logout</v-icon>
            {{ $t("logout") }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import mainMixin from "../../mixins/mainMixin"
export default {
  mixins:[mainMixin],
  methods: {
    toggleDrawer() {
      this.$emit("toggleDrawer");
    },
    logout() {
      if (this.$router.history.current.name !== "login") {
        this.$router.push({name: "login"});
      }

      this.$store.state.userDoc.id = "";
      this.$store.state.userDoc.username = "";
      this.$store.state.userDoc = {};
      if(this.$store.state.userDoc.phone){ this.$store.state.userDoc.phone=""; } // just append so some where will not
      localStorage.clear();
    },
    changeLanguage() {
      this.$i18n.locale = this.$i18n.locale === "km" ? "en" : "km";
      this.$vuetify.lang.current = this.$i18n.locale;

    },
    decryptFn(val){
      return this.my_decrypt(val);
    },
    gotoHome(){
        this.$router.push({ name: 'home' }).catch(() => {});
    },
  },
  created(){
     
  },
  computed: {

    // breadCrumbs: function () {
    //   let pathArray = this.$route.path.split("/");
    //   pathArray.shift();
    //   const breadCrumbs = [];
    //   let breadcrumb = "";
    //   let lastIndexFound = 0;
    //   for (let i = 0; i < pathArray.length; ++i) {
    //     breadcrumb = `${breadcrumb}${"/"}${pathArray[i]}`;
    //     if (
    //         this.$route.matched[i] &&
    //         Object.hasOwnProperty.call(this.$route.matched[i], "meta") &&
    //         Object.hasOwnProperty.call(this.$route.matched[i].meta, "breadCrumb")
    //     ) {
    //       breadCrumbs.push({
    //         href:
    //             i !== 0 && pathArray[i - (i - lastIndexFound)]
    //                 ? "/" + pathArray[i - (i - lastIndexFound)] + breadcrumb
    //                 : breadcrumb,
    //         disabled: i + 1 === pathArray.length,
    //         text: this.$route.matched[i].meta.breadCrumb || pathArray[i]
    //       });
    //       lastIndexFound = i;
    //       breadcrumb = "";
    //     }
    //   }
    //   return breadCrumbs;
    // }
  }
};
</script>
